/*
 * @Descripttion: 科研经费报销表 接口
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-02-14
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-02-14
 */

import http from '@/utils/kq/http'

const veJkyFundClaimApi = {
  //添加接口
  add(data){
    return http.post(http.service.jkl+'veJkyFundClaim/add',data)
  },
  //删除接口
  delete(ids){
    return http.delete(http.service.jkl+'veJkyFundClaim/deleteBatch?ids='+ids)
  },
  //修改接口
  update(data){
    return http.put(http.service.jkl+'veJkyFundClaim/edit',data)
  },
  //分页查询接口
  page(pageData){
    return http.post(http.service.jkl+'veJkyFundClaim/page',pageData)
  },
  //查询单个数据接口
  get(id){
    return http.get(http.service.jkl+'veJkyFundClaim/queryById',{id:id})
  },
  //更新状态
  updateStatus(data){
    return http.post(http.service.jkl+'veJkyFundClaim/updateStatus',data)
  },

};
export default veJkyFundClaimApi;
